<div class="dialog-header flex row justify-space-between">
  <h1 mat-dialog-title>
    {{ data.title || 'Code Editor' }}
  </h1>
  <mat-icon
    [mat-dialog-close]="null"
    class="cursor-pointer"
    matTooltip="Close"
    (click)="close()">
    close
  </mat-icon>
</div>

<div mat-dialog-content class="code-editor-dialog-content">
  <!-- Preloader overlay -->
  <div *ngIf="isLoading" class="monaco-preloader">
    <span class="gtb-loader small"></span>
    <p class="loading-text">Loading editor...</p>
  </div>

  <!-- Monaco Editor -->
  <ngx-monaco-editor
    [options]="editorOptions"
    [(ngModel)]="currentCode"
    (onInit)="onEditorInit($event)"
    class="fullscreen-monaco-editor">
  </ngx-monaco-editor>
</div>

<div mat-dialog-actions class="dialog-actions" align="end">
  <button
    mat-button
    (click)="cancel()"
    type="button">
    Cancel
  </button>
  <button
    mat-flat-button
    color="primary"
    (click)="save()"
    type="button">
    Save
  </button>
</div>